// -- [Shared CTA button: primary | secondary | onBrand | success]

import type { ButtonHTMLAttributes, ReactNode } from 'react'

export type ButtonVariant = 'primary' | 'secondary' | 'onBrand' | 'success'

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary:
    'bg-brand-orange text-white hover:bg-brand-orange/90 focus-visible:ring-brand-orange',
  secondary:
    'border-2 border-brand-orange text-brand-orange bg-transparent hover:bg-brand-orange/10 focus-visible:ring-brand-orange',
  onBrand:
    'bg-white text-gray-900 hover:bg-white/95 focus-visible:ring-white',
  success:
    'bg-green-600 text-white hover:bg-green-500 focus-visible:ring-green-500',
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  children: ReactNode
  /** -- Extra classes merged after variant styles */
  className?: string
}

export function Button({
  variant = 'primary',
  children,
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 min-h-12 rounded-lg px-5 py-3 font-semibold transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:pointer-events-none ${VARIANT_CLASS[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  )
}

export function SuccessTickIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M16.5 5.5l-9 9-4-4" />
    </svg>
  )
}
